import * as React from 'react';
import { observer } from 'mobx-react';

// Style
import './Content.css';

// Component
export interface IProps {
    children?: JSX.Element | JSX.Element[] ;
}
function Content(props: IProps) {
    return (
        <div className="App__Content">
            {props.children}
        </div>
    );
}

export default observer(Content);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/Content.tsx